import { call, put } from 'redux-saga/effects';

import { ISessionTranscript } from './session-transcripts.types';
import * as actions from './session-transcripts.actions';
import { apiRequest } from '../../api/api.saga-services';
import * as api from '../../api/request-config/session-transcript.api';
import { ISession } from '../session/session.types';
import { IFetchSessionTranscriptActionParams } from '../../page/session-transcript/transcripts.types';

export function* fetchSessionTranscripts(sessionId: ISession['id'], params?: IFetchSessionTranscriptActionParams) {
  const meetingTranscripts: ISessionTranscript[] = yield call(
    apiRequest,
    api.fetchSessionTranscriptApi(sessionId, params),
  );
  if (!meetingTranscripts) {
    return;
  }

  return meetingTranscripts;
}

export function* storeSessionTranscript(meetingTranscript: ISessionTranscript) {
  yield put(actions.storeSessionTranscript(meetingTranscript));
  return meetingTranscript;
}

export function* clearSessionTranscript(meetingTranscriptId: ISessionTranscript['id']) {
  yield put(actions.clearSessionTranscript(meetingTranscriptId));
}
